import { useContext } from "react";
import { context } from "../../../../context/context";

function GuarantorCard({ data, setUserInfo, deleteUser }) {
  const { utils } = useContext(context);
  return (
    <div className="bg-white/50 w-full shadow-md mx-auto rounded-xl divide-y">
      <div className="flex flex-col gap-3 text-gray-500 py-4">
        <div className="flex flex-col md:flex-row px-4 items-center gap-4">
          <p className="w-full md:w-6/12 text-sm">
            نام و نام خوانوادگی : {data?.name}
          </p>
          <p className="w-full md:w-6/12 text-sm">موبایل : {data?.mobile}</p>
        </div>
        <div className="flex flex-col md:flex-row px-4 items-center gap-4">
          <p className="w-full md:w-6/12 text-sm">
            شماره ملی : {data?.nationalId}
          </p>
          <p className="w-full md:w-6/12 text-sm">وضعیت : {utils?.LOAN_GUARANTOR_STATUS?.[data?.status]?.name}</p>
        </div>
        <div className="flex flex-col md:flex-row px-4 items-center gap-4">
          <p className="w-full md:w-6/12 text-sm">شغل : {data?.job}</p>

          <p className="w-full md:w-6/12 text-sm">
            شماره حساب : {data?.bankAccountId}
          </p>
        </div>
        <div className="w-11/12 mx-auto flex items-center justify-end gap-2 mt-4">
          <button
            onClick={() => deleteUser(data)}
            type="button"
            className="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
          >
            حذف
          </button>
          <button
            onClick={() => setUserInfo(data)}
            type="button"
            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            نمایش اطلاعات
          </button>
        </div>
      </div>
    </div>
  );
}

export default GuarantorCard;
